// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PopupHeaderProgress__container-beffa8 {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  gap: 4px;
}

.PopupHeaderProgress__step-ba80f9 {
  width: 16px;
  height: 4px;
  border-radius: 999px;
  opacity: 0.2;
  background: var(--base-120);
  transition: opacity 0.15s ease;
}

.PopupHeaderProgress__step-active-a91d80 {
  background: var(--brand-primary-40);
  opacity: 1;
}`, "",{"version":3,"sources":["webpack://./../../packages/ui-kit/src/PopupHeaderProgress/PopupHeaderSteps.style.m.css"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,aAAA;EACA,QAAA;AACF;;AAEA;EACE,WAAA;EACA,WAAA;EACA,oBAAA;EACA,YAAA;EACA,2BAAA;EACA,8BAAA;AACF;;AAEA;EACE,mCAAA;EACA,UAAA;AACF","sourcesContent":[".container {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  display: flex;\n  gap: 4px;\n}\n\n.step {\n  width: 16px;\n  height: 4px;\n  border-radius: 999px;\n  opacity: 0.2;\n  background: var(--base-120);\n  transition: opacity 0.15s ease;\n}\n\n.step-active {\n  background: var(--brand-primary-40);\n  opacity: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `PopupHeaderProgress__container-beffa8`,
	"step": `PopupHeaderProgress__step-ba80f9`,
	"step-active": `PopupHeaderProgress__step-active-a91d80`,
	"stepActive": `PopupHeaderProgress__step-active-a91d80`
};
module.exports = ___CSS_LOADER_EXPORT___;
